import { $router, setup } from './instance'

// TODO: make stable after migration
export const $$unstable_router = { setup, $router }

export { rootRoute } from './root'
export { secureScope, publicScope } from './scope'
